<div
	class="flex p-10 flex-col items-center justify-center w-full bg-neutral-50 dark:bg-neutral-900 rounded-3xl">
	<div class="flex gap-1 text-3xl">
		@if (value()) {
			<span class="rounded-full whitespace-nowrap text-right">
				{{ value() }}</span
			>
		} @else {
			<span>n/a</span>
		}
	</div>

	@if (title()) {
		<span class="text-sm subtle-text">{{ title() | transloco }}</span>
	} @else {
		<span>n/a</span>
	}
</div>
